import { Menu, MenuItem, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';

export interface UserActionsMenuOption {
  label: string;
  onClick: () => void;
  /** When true the label is styled as a destructive action (red). */
  isDestructive?: boolean;
}

interface UserActionsMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  options: UserActionsMenuOption[];
  anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' };
  transformOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' };
  /** Overrides applied on top of the default option label styles. */
  labelSx?: SxProps<Theme>;
}

const UserActionsMenu: FC<UserActionsMenuProps> = ({
  anchorEl,
  onClose,
  options,
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
  labelSx,
}) => {
  const handleItemClick = (action: UserActionsMenuOption) => {
    action.onClick();
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      slotProps={{
        paper: {
          sx: {
            borderRadius: '0.5rem',
            border: '1px solid #E8EAEB',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            minWidth: '160px',
          },
        },
      }}
    >
      {options.map((option) => {
        const color = option.isDestructive ? '#FF6347' : '#162936';
        return (
          <MenuItem
            key={option.label}
            onClick={() => handleItemClick(option)}
            sx={{
              fontSize: '0.875rem',
              fontWeight: 500,
              color,
              padding: '0.625rem 1rem',
              '&:hover': { backgroundColor: '#F5F5F5' },
            }}
          >
            <Typography
              sx={[
                { fontSize: '0.875rem', fontWeight: 500, color },
                ...(Array.isArray(labelSx) ? labelSx : [labelSx]),
              ]}
            >
              {option.label}
            </Typography>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default UserActionsMenu;
